import React from "react";
import { useTranslation } from "react-i18next";

const AlreadyResponded: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="p-4 rounded-3 bg-white">
      <h2 className="h3">
        <i className="fa-sharp fa-light fa-circle-check me-2"></i>{t("Form.CompletionView.AlreadySent.Title")}
      </h2>
      <p className="text-muted fs-12 mb-0">{t("Form.CompletionView.AlreadySent.Description")}</p>
    </div>
  );
};

export default AlreadyResponded;
